import React from "react";
import { useEffect } from "react";
export default function Offer() {
  useEffect(() => {
    document.title = "Offers";
  }, []);
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Offers",
      link: "/offers",
    },
  ];
  return (
    <div style={styles.page}>
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbItems.map((item, i) => (
              <li
                key={i}
                className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
              >
                {i === breadcrumbItems.length - 1 ? (
                  item.label
                ) : (
                  <a href={item.link}>{item.label}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      <img
        src="./images/ads/offer-8.jpg"
        height="800px"
        width="800px"
        alt="offer-8"
        style={{ margin: "20px", marginTop: "0px" }}
      />
    </div>
  );
}
const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f6f8fc, #eef2f7)",
    padding: "20px 15px",
  },
};
